import React from 'react';
import propTypes from 'prop-types';
import { Label, ReferenceDot, ReferenceLine } from 'recharts';

import COLORS from 'constants/colors';
import { UNIT_TYPES } from 'constants/unitTypes';
import { inferUnit } from 'util/unitConversion';
import { formatNumberRoundToNearest } from 'util/formatters/numberFormatter';

const FieldAverageReferences = ({ 
  minYield,
  newPlan: {
    plantingRate: newPlanPlantingRate,
    estimatedYield: newPlanEstimatedYield
  },
  fvss: {
    plantingRate: fvssPlantingRate,
    estimatedYield: fvssEstimatedYield
  }}) => {
  // The estimated yield is rounded for bu/ac and bags/ha, but keeps one decimal for mt/ha. 
  const roundValue = inferUnit('area-density.yield').unitKey === UNIT_TYPES.mt_ha ? 0.1 : 1;
  const estimatedYield = formatNumberRoundToNearest(newPlanEstimatedYield, roundValue);

  return (
    <React.Fragment>
      <ReferenceDot
        r={0}
        x={fvssPlantingRate}
        y={minYield}
        fill={COLORS.scenarios.recommendation}
        stroke={COLORS.scenarios.recommendation}
      />
      {/* This is the vertival line that points to the FVSS. */}
      <ReferenceLine
        ifOverflow='hidden'
        strokeDasharray="3 3"
        strokeOpacity={0.6}
        stroke={COLORS.scenarios.recommendation}
        segment={[
          { x: fvssPlantingRate, y: 0 },
          { x: fvssPlantingRate, y: fvssEstimatedYield },
        ]}
      />
      {/* This is the horizontal line that points to the FVSS. */}
      <ReferenceLine
        ifOverflow='hidden'
        strokeDasharray="3 3"
        strokeOpacity={0.6}
        stroke={COLORS.scenarios.recommendation}
        segment={[
          { x: 0, y: fvssEstimatedYield },
          { x: fvssPlantingRate, y: fvssEstimatedYield },
        ]}
      />
      {/* This is the horizontal line that points to the new plan. */}
      <ReferenceLine
        ifOverflow='hidden'
        strokeDasharray="3 3"
        strokeOpacity={0.3}
        stroke={COLORS.scenarios.newPlan}
        segment={[
          { x: 1000, y: newPlanEstimatedYield },
          { x: newPlanPlantingRate, y: newPlanEstimatedYield },
        ]}
      >
        <Label value={estimatedYield} fill={COLORS.scenarios.newPlan} position='insideRight' offset={20}/>
      </ReferenceLine>
    </React.Fragment>
  );
};

FieldAverageReferences.propTypes = {
  newPlan: {
    plantingRate: propTypes.number,
    estimatedYield: propTypes.number
  },
  fvss: {
    plantingRate: propTypes.number,
    estimatedYield: propTypes.number    
  },
  minYield: propTypes.number
};

export default FieldAverageReferences;
